import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { toast } from "react-toastify";
import { timesheetApi, allocationService, Util, userAllocationService } from "../../services";
import { contactService } from "../../services/profile";
import { ManagerAllocation } from "../allocation/manager-allocation";
import { Sidebar } from "primereact/sidebar";
import { userService } from "../../services/extensions";
import { capitalize } from "../../services/utility/helper";
import { Tooltip } from "primereact/tooltip";

function ActionCards({ actionList = [], approvalList = [], timesheetList = [], role = "employee", managerDashboardReload }) {
  const [myApprovalList, setMyApprovalList] = useState(false);
  const [tabIndex, setTabIndex] = useState(1);
  const [show, setShow] = useState(false);
  const [approvalData, setApprovalData] = useState({});
  const [ac, setAc] = useState(false);
  var mergedData = [...timesheetList, ...approvalList];
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [allocationTypes, setAllocationTypes] = useState([]);
  const [userProfileDetails, setUserProfileDetails] = useState({});
  const [timesheetTab, setTimesheetTab] = useState(false);
  const [changeActionTab, setChangeActionTab] = useState(false);

  useEffect(() => {
    if (timesheetList) {
      setTimesheetTab(true);
    }
    if (changeActionTab) {
      getTabIndex(tabIndex);
    }
  }, [myApprovalList]);

  const getProjects = () => {
    allocationService.getActiveProjects().then((resp) => {
      setProjects(resp.data.data);
    });
  };

  const getUsers = () => {
    userService.getUsers().then((resp) => {
      const dataObj = resp.data.data.map((v, i) => ({
        ...v,
        name: resp.data.data[i].firstName + " " + resp.data.data[i].lastName,
      }));
      var activeUsers = [];
      activeUsers = dataObj.filter((i) => {
        return i.status === 1;
      });
      setUsers(activeUsers);
    });
  };

  const getAllocationType = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocationTypes(resp.data.data);
    });
  };

  const userProfileInfo = (ecn) => {
    let param = { ecn: ecn };
    contactService.getUserByFilter(param).then((resp) => {
      if (resp) {
        setUserProfileDetails(resp?.data?.data[0]);
      }
    });
  };

  const navigateTimeLine = (el) => {
    navigate('/timeline?action=app&id=' + el.userId)
    localStorage.setItem('userPhoto', el.photo)
  }

  const getTabIndex = (e) => {
    setChangeActionTab(true);
    setMyApprovalList(false);
    switch (tabIndex) {
      case 1:
        timesheetApi.getManagerRecentApprovalList().then((resp) => {
          try {
            mergedData = [
              ...resp.data.data.timesheet,
              ...resp.data.data.allocation,
            ];
          } catch (error) {
            // Error handle
          }
        });
        break;
      default:
        timesheetApi.getManagerRecentApprovalList().then((resp) => {
          try {
            mergedData = [
              ...resp.data.data.timesheet,
              ...resp.data.data.allocation,
            ];
          } catch (error) {
            // Error handle
          }
        });
        break;
    }
  };

  let EmpActionCardApproval;
  let EmpActionCardTimesheet;
  const sendApprovalReminder = (id) => {
    var mgrName = JSON.parse(localStorage.user);
    let body;
    body = {
      timesheetId: id
    }
    try {
      userAllocationService.updateTimesheetApprovalAction(body).then((resp) => {
        toast.success("Reminder sent successfully to " + capitalize(mgrName.superior.firstName + " " + mgrName.superior.lastName)
        );
      });
    } catch (error) {
      toast.error("Unable to send reminder");
    }
  };

  if (actionList.pendingApproval) {
    EmpActionCardApproval = actionList.pendingApproval.map((el, index) => {
      return (
        <div key={'eaca' + el.date + index} className={classNames("col-4", "ess-act-card", "ess-card-theam-" + (index + 2))}>
          <div className="ess-act-header">
            <strong>Pending Approval</strong>
          </div>
          <div className="ess-act-body">
            <div className="container">
              <p>Pending Approval on timesheet by your manager</p>
              <div className="card-date">
                <div>
                  <strong>{Util.dateConvertToShort(el.date)}</strong>
                </div>
              </div>
            </div>
            <div className="ess-act-footer">
              <div style={{ float: "left" }}>
              </div>
              <div style={{ textAlign: "right" }}>
                <Button label="Ask for Approval" className="p-button-sm p-button-rounded" onClick={() => sendApprovalReminder(el.id)} />
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  if (actionList?.pendingTimesheet?.length > 0) {
    EmpActionCardTimesheet = (
      <div className={classNames("col-4", "ess-act-card", "ess-card-theam-1")}>
        <div className="ess-act-header">
          <strong>Pending Timesheet</strong>
        </div>
        <div className="ess-act-body">
          <div className="container">
            <p>Please fill your timesheet and avoid delay in payroll</p>
            <div className="card-date">
              <div>
                <strong className="custom-tooltip-btn"> {actionList?.pendingTimesheet?.length} {actionList?.pendingTimesheet?.length > 1 ? "Days" : "Day"} <i className="pi pi-info-circle"></i></strong>
                <Tooltip target=".custom-tooltip-btn">
                  {
                    actionList?.pendingTimesheet?.filter((i, index) => (index < 10)).map((i, index) => {
                      return (
                        <span key={'pts' + index}>
                          <p> {i}  </p>
                          <p>{index > 8 ? "... To see more. Click on Fill Now" : ''}</p>
                        </span>
                      )
                    })
                  }
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="ess-act-footer">
            <div style={{ float: "left" }}></div>
            <div style={{ textAlign: "right" }}>
              <Button label="Fill Now" className="p-button-sm p-button-rounded" onClick={() => navigate("/create-timesheet?action=dashboard&date=" + actionList?.pendingTimesheet[0])} />
            </div>
          </div>
        </div>
      </div>
    );
    // return EmpActionCardTimesheet;
  }

  const allocateNow = (rowData) => {
    getProjects();
    getUsers();
    getAllocationType();
    setApprovalData(rowData);
    userProfileInfo(rowData.User.ecn);
    setShow(true);
    setAc(true);
  };

  const AddAllocationDialog = () => {
    return (
      <Sidebar className="p-sidebar-md" position="right" visible={show} onHide={() => setShow(false)}>
        <ManagerAllocation
          projects={projects}
          users={users}
          allocationTypes={allocationTypes}
          setShow={setShow}
          approveData={approvalData}
          dashboardReload={managerDashboardReload}
          userProfileDetails={userProfileDetails}
          ac={ac}
        />
      </Sidebar>
    );
  };

  const MgrActionCardTimesheet = mergedData.slice(0, 3).map((el, index) => {
    return (
      <Fragment>
        {AddAllocationDialog()}
        <div key={'mact' + index} className={classNames("col-4", "ess-act-card", "ess-card-theam-" + (index + 1))}>
          <div className="ess-act-header">
            {timesheetTab ? (
              (el?.comments !== null) ? (
                <strong>Recall Timesheet Approval</strong>
              ) : (
                <strong>Timesheet Approval</strong>
              )
            ) : (
              ""
            )}
            {el.Allocation && <strong>Allocation Pending</strong>}
          </div>
          <div className="ess-act-body">
            <div className="container">
              {el.Allocation && (
                <p> Allocation Pending for{" "}
                  {el.User && (<strong className="capitalize"> {el.User.firstName + " " + el.User.lastName} </strong>)}
                </p>
              )}
              {timesheetTab ? (
                (el?.comments !== null) ? (
                  <p><strong className="capitalize"> {el.firstName + " " + el.lastName} </strong>
                    {" "}
                    Requested Timesheet Recall for
                  </p>
                ) : (
                  <p>
                    <strong className="capitalize"> {el.firstName + " " + el.lastName} </strong>
                    {" "}
                    Filled Timesheet For
                  </p>
                )
              ) : (
                ""
              )}
              <div className="card-date">
                {timesheetTab && (
                  <div>
                    <strong className={"custom-tooltip-btn-" + index}> {el?.count}   {el?.count > 1 ? "Days" : "Day"} <i className="pi pi-info-circle"></i></strong>
                    <Tooltip target={".custom-tooltip-btn-" + index}>
                      {
                        el?.date?.filter((i, index) => (index < 10)).map((i, index) => {
                          return (
                            <>
                              <p> {i}  </p>
                              <p>{index > 8 ? "... To see more. Click on Review & Approve Now" : ''}</p>
                            </>
                          )
                        })
                      }
                    </Tooltip>
                  </div>
                )}
                {el.Allocation && (
                  <strong>{el.Allocation.Project.title}</strong>
                )}
              </div>
            </div>
            <div className="ess-act-footer">
              <div style={{ float: 'left' }}>
                <a href='#' className='m-link' onClick={() => navigateTimeLine(el)}>View Timeline<i className="pi pi-arrow-up-right"></i></a>
              </div>
              {el.Allocation && (
                <div style={{ float: "left" }}></div>
              )}
              <div style={{ textAlign: "right" }}>
                {timesheetTab ? (
                  (el?.comments !== null) ? (
                    <Button label="Review & Approve Now" className="p-button-sm p-button-rounded" onClick={() => navigate("/timesheets?action=app&id=" + el.userId + "&status=RECALL")} />
                  ) : (
                    <Button label="Review & Approve Now" className="p-button-sm p-button-rounded" onClick={() => navigate("/timesheets?action=app&id=" + el.userId + "&status=REVIEW")} />
                  )
                ) : (
                  ""
                )}
                {el.Allocation && (
                  <Button label="Allocate Now" className="p-button-sm p-button-rounded" onClick={(e) => allocateNow(el)} />
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  });

  return (
    <Fragment>
      <div className="grid">
        {role === "employee" ? EmpActionCardTimesheet : ""}
        {role === "employee" ? EmpActionCardApproval : MgrActionCardTimesheet}
      </div>
    </Fragment>
  );
}

export default ActionCards;